"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _withWidth = _interopRequireDefault(require("@material-ui/core/withWidth"));
var _ComponentContainer = require("../../../../Framework/ComponentContainer");
var _createSelector = _interopRequireDefault(require("../../../../Utils/Function/createSelector"));
var _findIndex = _interopRequireDefault(require("lodash/findIndex"));
var _AddGalleryImage = _interopRequireDefault(require("../Components/AddGalleryImage"));
var _Progress = _interopRequireDefault(require("../../../Shared/Components/Progress/Progress"));
var _Actions = require("../../../Reducers/ImageGallery/Actions");
var _Selectors = require("../../../Reducers/UI/Selectors");
var _configuration = require("../../../configuration");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var getTags = (0, _createSelector["default"])(function (imageGalleryState) {
  return imageGalleryState.tags;
}, function (imageGalleryState) {
  return imageGalleryState.selectedTag;
}, function (imageGalleryState) {
  return imageGalleryState.selectedTags;
}, function (tags, selectedTag, selectedTags) {
  return tags.map(function (tag) {
    return {
      title: tag.title,
      checked: selectedTags && (0, _findIndex["default"])(selectedTags, function (selectedTag) {
        if (selectedTag.title === tag.title) {
          return selectedTag.checked;
        }
      }) > -1
    };
  });
});
var getGalleryImages = (0, _createSelector["default"])(function (imageGalleryState) {
  return imageGalleryState.gallery;
}, function (images) {
  var host = (0, _configuration.getConf)('network.host');
  return images.map(function (image) {
    return _objectSpread(_objectSpread({}, image), {}, {
      url: "".concat(host).concat(image.thumbUrl)
    });
  });
});
var getLoadingState = (0, _Selectors.createBackgroundWorkStateSelector)(_Actions.WN_LOAD_TAGS, _Actions.WN_LOAD_IMAGES);
var mapStateToProps = function mapStateToProps(state) {
  return {
    Component: _AddGalleryImage["default"],
    ProgressComponent: _Progress["default"],
    tags: getTags(state.imageGallery),
    images: getGalleryImages(state.imageGallery),
    loading: getLoadingState(state.ui)
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    loadTags: function loadTags() {
      return dispatch((0, _Actions.fetchTags)());
    },
    onSelectTag: function onSelectTag(tags) {
      return dispatch((0, _Actions.selectTags)(tags));
    },
    dismissError: function dismissError() {
      return dispatch((0, _Actions.dismissError)());
    }
  };
};
var _default = exports["default"] = (0, _withWidth["default"])()((0, _ComponentContainer.containerConnect)(mapStateToProps, mapDispatchToProps));